import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import { useParams } from 'react-router';
import routes from '../../../routing/routes';
import forum from '../icons/forum.svg';
import { useUserContext } from '../../../context/UserContext';
import { canSendOrAdd } from '../../../function/permissions';
import UserRole from '../../../model/currentuser/UserRole';
import Secured from '../../Secured';

interface Props {
  setOpenDropdown: (isOpen: boolean) => void;
}

const AddHromadnaPripomienkaButton = ({ setOpenDropdown }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const { pouzivatel, legislationProcess } = useUserContext();

  return (
    <Secured
      allowForRoles={[UserRole.VEREJNOST, UserRole.PRIPOMIENKOVATEL, UserRole.NELEGISLATIVNA_ORGANIZACIA]}
      additionalCheck={canSendOrAdd(pouzivatel, legislationProcess)}
    >
      <li key="Pridať hrom. pripomienku" className="action-item">
        <div className="icon-wrapper">
          <img src={forum} className="icon" alt="Pridať hrom. pripomienku" />
        </div>
        <Link
          onClick={() => setOpenDropdown(false)}
          to={routes.hromadnePripomienky.add.withParams(type, year, index)}
          className="button-inline-text"
        >Pridať hromadnú pripomienku
        </Link>
      </li>
    </Secured>
  );
};

export default AddHromadnaPripomienkaButton;
